import { IError } from '@app/models/error';

import { INN_ERROR_CODES, INN_ERROR_POINTER } from '../constants';

export const isInnError = (error: IError): boolean =>
  error.source?.pointer === INN_ERROR_POINTER || INN_ERROR_CODES.includes(error.code);
